<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'RECURRENCES.FILTER.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <div class="filter-subtitle mt-16">
    {{ 'RECURRENCES.FILTER.INTERVAL.TITLE' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="intervalIn">
    <mat-checkbox
      labelPosition="before"
      *ngFor="let interval of intervals; let $index = index"
      [formControlName]="$index"
    >
      {{ interval.name | translate }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>
  <company-legacy class="mt-16" formControlName="companyId"></company-legacy>

  <mat-divider class="mt-16"></mat-divider>
  <maintenance-type-legacy class="mt-16" formControlName="maintenanceTypeId"></maintenance-type-legacy>

  <mat-divider class="mt-16"></mat-divider>
  <segment-legacy class="mt-16" formControlName="segmentId"></segment-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-locations-input [control]="filtersForm.get('locations')" [desiredStyle]="desiredStyle"></fc-locations-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>
  <div class="filter-subtitle mt-16">
    {{ 'RECURRENCES.FILTER.SITUATION' | translate }}
  </div>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">
        {{ 'RECURRENCES.FILTER.ACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'RECURRENCES.FILTER.INACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'RECURRENCES.FILTER.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>
</form>
